
// author details
const siteDetails = {
  author: {
    title: "Kaleem Ulah",
    titleTag: `h3`,
    titleEC: `text-[24px] text-[#333333] font-[500]`,
    image: {
      path: "blog-author-image",
      alt: "blog-author-image",
    },
    description: `Kaleem is CEO & Author at "Synkli". With more than 10 years of experience in financial services, he built Kalculators to transform your financial challenges into strategic triumphs!`,
  },
  partnersWebsiteLinks: {
    home: `https://partners.synkli.com.au/`,
    signUpPage: `https://partners.synkli.com.au/signup/`,
    announcementsPage: `https://partners.synkli.com.au/announcement/`,
    workspacePage: `https://partners.synkli.com.au/workspace/`,
    leadsPage: `https://partners.synkli.com.au/leads/`,
  },
  postTypes: {
    articles: {
      slug: `articles`,
      link: `/articles/`,
    },
    newsAndUpdates: {
      slug: `news-and-updates`,
      link: `/news-and-updates/`,
    },
    blogs: {
      slug: `blogs`,
      link: `/blogs/`,
    },
    caseStudies: {
      slug: `case-studies`,
      link: `/case-studies/`,
    },
    features: {
      slug: `features`,
      link: `/features/`,
    },
    events: {
      slug: `events`,
      link: `/events/`,
    },
    releaseNotes: {
      slug: `release-notes`,
      link: `/release-notes/`,
    },
  },
  appLinks: {
    googlePlay: {
      link: `https://play.google.com/store/apps/details?id=com.synkli.au&hl=en&pli=1`,
      icon: `google-play`,
    },
    applePay: {
      link: `https://apps.apple.com/au/app/synkli/id6479931845`,
      icon: `apple-pay`,
    },
  },
  pageMenuLinks: {
    dashboardPage: {
      slug: `dashboard`,
      link: `/dashboard/`,
    },
    synkliSupportPage: {
      slug: `synkli-support`,
      link: `/synkli-support/`,
    },
    describeIssuePage:{
      slug: `describe-issue`,
      link: `/describe-issue/`
    },
    knowledgeBasePage: {
      slug: `knowledge-base`,
      link: `/knowledge-base/`,
    },
    supportTicket: {
      slug: `support-ticket`,
      link: `/support-ticket/`,
    },
    ticketDashboard: {
      slug: `ticket-dashboard`,
      link: `/ticket-dashboard/`,
    },
    ticketDetails: {
      slug: `ticket-details`,
      link: `/ticket-details/`,
    },
    loginPage: {
      slug: `user-auth/?auth-type=login`,
      link: `/user-auth/?auth-type=login`,
    },
    signupPage: {
      slug: `user-auth/?auth-type=signup`,
      link: `/user-auth/?auth-type=signup`,
    },
    accountantPage: {
      slug: `accountants-and-bookkeepers`,
      link: `/accountants-and-bookkeepers/`,
    },
    businessesPage: {
      slug: `businesses`,
      link: `/businesses/`,
    },
    soleTradersPage: {
      slug: `sole-traders`,
      link: `/sole-traders/`,
    },
    individualsPage: {
      slug: `individuals`,
      link: `/individuals/`,
    },
    productsPage: {
      slug: `products`,
      link: `/products/`,
    },
    pricingPage: {
      slug: `pricing`,
      link: `/pricing/`,
    },
    aboutUsPage: {
      slug: `about-us`,
      link: `/about-us/`,
    },
    contactUsPage: {
      slug: `contact-us`,
      link: `https://synkli.com.au/contact-us/`,
    },
    helpAndSupportPage: {
      slug: `help-and-support`,
      link: `/help-and-support/`,
    },
    privacyPolicyPage: {
      slug: `privacy-policy`,
      link: `/privacy-policy/`,
    },
    termsAndConditionsPage: {
      slug: `terms-and-conditions`,
      link: `/terms-and-conditions/`,
    },
    faqsPage: {
      slug: `faqs`,
      link: `/faqs/`,
    },
    aiSearchPage: {
      slug: `ai-search`,
      link: `/ai-search/`,
    },
    featurePages: {
      // outlookAddin: {
      //     slug: `outlook-addin`,
      //     link: `/outlook-addin/`,
      // },
      onlineSignature: {
        slug: `online-signature`,
        link: `/online-signature/`,
      },
      expenseAndIncomeManagement: {
        slug: `expense-and-income-management`,
        link: `/expense-and-income-management/`,
      },
      claimDeductions: {
        slug: `claim-deductions`,
        link: `/claim-deductions/`,
      },
      clientOnboarding: {
        slug: `client-onboarding`,
        link: `/client-onboarding/`,
      },
      taskManagementAndReporting: {
        slug: `task-management-and-reporting`,
        link: `/task-management-and-reporting/`,
      },
      // teamManagement: {
      //     slug: `team-management`,
      //     link: `/team-management/`
      // },
      // connectToXero: {
      //     slug: `connect-to-xero`,
      //     link: `/connect-to-xero/`
      // },
      // documentHub: {
      //     slug: `document-hub`,
      //     link: `/document-hub/`
      // },
      clientManagement: {
        slug: `client-management`,
        link: `/client-management/`,
      },
      // synkliCapture: {
      //     slug: `synkli-capture`,
      //     link: `/synkli-capture/`
      // },
      jobManager: {
        slug: `job-manager`,
        link: `/job-manager/`,
      },
      emailManager: {
        slug: `email-manager`,
        link: `/email-manager/`,
      },
      collateDocuments: {
        slug: `collate-documents`,
        link: `/collate-documents/`,
      },
      deedBuilder: {
        slug: `deed-builder`,
        link: `/deed-builder/`,
      },
      thirdPartyAppsIntegrations: {
        slug: `third-party-apps-integrations`,
        link: `/third-party-apps-integrations/`,
      },
      // efficientProfilesDataBuilding: {
      //     slug: `efficient-profiles-data-building`,
      //     link: `/efficient-profiles-data-building/`
      // },
      // multipleProfilesManagement: {
      //     slug: `multiple-profiles-management`,
      //     link: `/multiple-profiles-management/`
      // },
      // businessProfileManagement: {
      //     slug: `business-profile-management`,
      //     link: `/business-profile-management/`
      // },
      atoCompliantEthicalClearance: {
        slug: `ato-tpb-compliant-ethical-clearance`,
        link: `/ato-tpb-compliant-ethical-clearance/`,
      },
      // agentNominationWizard: {
      //     slug: `ato-mygovid-gdpr-compliant-agent-nomination`,
      //     link: `/ato-mygovid-gdpr-compliant-agent-nomination/`
      // },
      // documentManagement: {
      //     slug: `compliance-ready-document-management`,
      //     link: `/compliance-ready-document-management/`
      // },
      clientVerification: {
        slug: `ato-mygovid-compliant-agent-verification`,
        link: `/ato-mygovid-compliant-agent-verification/`,
      },
      relayRoom: {
        slug: `relay-room`,
        link: `/relay-room/`,
      },
      securityAndAuthentication: {
        slug: `security-and-authentication`,
        link: `/security-and-authentication/`,
      },
      workspaceManagement: {
        slug: `workspace-management`,
        link: `/workspace-management/`,
      },
    },
    caseStudyPages: {
      theKalculators: {
        slug: `the-kalculators-case-study`,
        link: `/the-kalculators-case-study/`,
      },
      qTaxCaseStudy: {
        slug: `q-tax-case-study`,
        link: `/q-tax-case-study/`,
      },
      theTotalCaseStudy: {
        slug: `the-total-case-study`,
        link: `/the-total-case-study/`,
      },
    },
    accountantWebPlatformPage: {
      slug: `accountant-web-platform`,
      link: `/accountant-web-platform/`,
    },
  },
  tabs: {
    accountantTab: {
      featurePages: {
        // outlookAddin: {
        //     slug: `outlook-addin`,
        //     link: `/outlook-addin/`,
        // },
        onlineSignature: {
          slug: `online-signature`,
          link: `/online-signature/`,
        },
        expenseAndIncomeManagement: {
          slug: `expense-and-income-management`,
          link: `/expense-and-income-management/`,
        },
        // claimDeductions: {
        //     slug: `claim-deductions`,
        //     link: `/claim-deductions/`
        // },
        clientOnboarding: {
          slug: `client-onboarding`,
          link: `/client-onboarding/`,
        },
        taskManagementAndReporting: {
          slug: `task-management-and-reporting`,
          link: `/task-management-and-reporting/`,
        },
        // teamManagement: {
        //     slug: `team-management`,
        //     link: `/team-management/`
        // },
        // connectToXero: {
        //     slug: `connect-to-xero`,
        //     link: `/connect-to-xero/`
        // },
        // documentHub: {
        //     slug: `document-hub`,
        //     link: `/document-hub/`
        // },
        clientManagement: {
          slug: `client-management`,
          link: `/client-management/`,
        },
        // synkliCapture: {
        //     slug: `synkli-capture`,
        //     link: `/synkli-capture/`
        // },
        jobManager: {
          slug: `job-manager`,
          link: `/job-manager/`,
        },
        emailManager: {
          slug: `email-manager`,
          link: `/email-manager/`,
        },
        collateDocuments: {
          slug: `collate-documents`,
          link: `/collate-documents/`,
        },
        deedBuilder: {
          slug: `deed-builder`,
          link: `/deed-builder/`,
        },
        thirdPartyAppsIntegrations: {
          slug: `third-party-apps-integrations`,
          link: `/third-party-apps-integrations/`,
        },
        // efficientProfilesDataBuilding: {
        //     slug: `efficient-profiles-data-building`,
        //     link: `/efficient-profiles-data-building/`
        // },
        // multipleProfilesManagement: {
        //     slug: `multiple-profiles-management`,
        //     link: `/multiple-profiles-management/`
        // },
        // businessProfileManagement: {
        //     slug: `business-profile-management`,
        //     link: `/business-profile-management/`
        // },
        atoCompliantEthicalClearance: {
          slug: `ato-tpb-compliant-ethical-clearance`,
          link: `/ato-tpb-compliant-ethical-clearance/`,
        },
        // agentNominationWizard: {
        //     slug: `ato-mygovid-gdpr-compliant-agent-nomination`,
        //     link: `/ato-mygovid-gdpr-compliant-agent-nomination/`
        // },
        // documentManagement: {
        //     slug: `compliance-ready-document-management`,
        //     link: `/compliance-ready-document-management/`
        // },
        clientVerification: {
          slug: `ato-mygovid-compliant-agent-verification`,
          link: `/ato-mygovid-compliant-agent-verification/`,
        },
        relayRoom: {
          slug: `relay-room`,
          link: `/relay-room/`,
        },
        securityAndAuthentication: {
          slug: `security-and-authentication`,
          link: `/security-and-authentication/`,
        },
        workspaceManagement: {
          slug: `workspace-management`,
          link: `/workspace-management/`,
        },
      },
    },
    businessesTab: {
      featurePages: {
        outlookAddin: {
          slug: `outlook-addin`,
          link: `/outlook-addin/`,
        },
        onlineSignature: {
          slug: `online-signature`,
          link: `/online-signature/`,
        },
        // expenseAndIncomeManagement: {
        //     slug: `expense-and-income-management`,
        //     link: `/expense-and-income-management/`
        // },
        claimDeductions: {
          slug: `claim-deductions`,
          link: `/claim-deductions/`,
        },
        clientOnboarding: {
          slug: `client-onboarding`,
          link: `/client-onboarding/`,
        },
        taskManagementAndReporting: {
          slug: `task-management-and-reporting`,
          link: `/task-management-and-reporting/`,
        },
        teamManagement: {
          slug: `team-management`,
          link: `/team-management/`,
        },
        connectToXero: {
          slug: `connect-to-xero`,
          link: `/connect-to-xero/`,
        },
        documentHub: {
          slug: `document-hub`,
          link: `/document-hub/`,
        },
        clientManagement: {
          slug: `client-management`,
          link: `/client-management/`,
        },
        synkliCapture: {
          slug: `synkli-capture`,
          link: `/synkli-capture/`,
        },
        jobManager: {
          slug: `job-manager`,
          link: `/job-manager/`,
        },
        emailManager: {
          slug: `email-manager`,
          link: `/email-manager/`,
        },
        collateDocuments: {
          slug: `collate-documents`,
          link: `/collate-documents/`,
        },
        deedBuilder: {
          slug: `deed-builder`,
          link: `/deed-builder/`,
        },
        thirdPartyAppsIntegrations: {
          slug: `third-party-apps-integrations`,
          link: `/third-party-apps-integrations/`,
        },
        efficientProfilesDataBuilding: {
          slug: `efficient-profiles-data-building`,
          link: `/efficient-profiles-data-building/`,
        },
        multipleProfilesManagement: {
          slug: `multiple-profiles-management`,
          link: `/multiple-profiles-management/`,
        },
        businessProfileManagement: {
          slug: `business-profile-management`,
          link: `/business-profile-management/`,
        },
        atoCompliantEthicalClearance: {
          slug: `ato-tpb-compliant-ethical-clearance`,
          link: `/ato-tpb-compliant-ethical-clearance/`,
        },
        agentNominationWizard: {
          slug: `ato-mygovid-gdpr-compliant-agent-nomination`,
          link: `/ato-mygovid-gdpr-compliant-agent-nomination/`,
        },
        documentManagement: {
          slug: `compliance-ready-document-management`,
          link: `/compliance-ready-document-management/`,
        },
        clientVerification: {
          slug: `ato-mygovid-compliant-agent-verification`,
          link: `/ato-mygovid-compliant-agent-verification/`,
        },
      },
    },
    soleTradersTab: {
      featurePages: {
        outlookAddin: {
          slug: `outlook-addin`,
          link: `/outlook-addin/`,
        },
        onlineSignature: {
          slug: `online-signature`,
          link: `/online-signature/`,
        },
        // expenseAndIncomeManagement: {
        //     slug: `expense-and-income-management`,
        //     link: `/expense-and-income-management/`
        // },
        claimDeductions: {
          slug: `claim-deductions`,
          link: `/claim-deductions/`,
        },
        clientOnboarding: {
          slug: `client-onboarding`,
          link: `/client-onboarding/`,
        },
        taskManagementAndReporting: {
          slug: `task-management-and-reporting`,
          link: `/task-management-and-reporting/`,
        },
        teamManagement: {
          slug: `team-management`,
          link: `/team-management/`,
        },
        connectToXero: {
          slug: `connect-to-xero`,
          link: `/connect-to-xero/`,
        },
        documentHub: {
          slug: `document-hub`,
          link: `/document-hub/`,
        },
        clientManagement: {
          slug: `client-management`,
          link: `/client-management/`,
        },
        synkliCapture: {
          slug: `synkli-capture`,
          link: `/synkli-capture/`,
        },
        jobManager: {
          slug: `job-manager`,
          link: `/job-manager/`,
        },
        emailManager: {
          slug: `email-manager`,
          link: `/email-manager/`,
        },
        collateDocuments: {
          slug: `collate-documents`,
          link: `/collate-documents/`,
        },
        deedBuilder: {
          slug: `deed-builder`,
          link: `/deed-builder/`,
        },
        thirdPartyAppsIntegrations: {
          slug: `third-party-apps-integrations`,
          link: `/third-party-apps-integrations/`,
        },
        efficientProfilesDataBuilding: {
          slug: `efficient-profiles-data-building`,
          link: `/efficient-profiles-data-building/`,
        },
        multipleProfilesManagement: {
          slug: `multiple-profiles-management`,
          link: `/multiple-profiles-management/`,
        },
        businessProfileManagement: {
          slug: `business-profile-management`,
          link: `/business-profile-management/`,
        },
        atoCompliantEthicalClearance: {
          slug: `ato-tpb-compliant-ethical-clearance`,
          link: `/ato-tpb-compliant-ethical-clearance/`,
        },
        agentNominationWizard: {
          slug: `ato-mygovid-gdpr-compliant-agent-nomination`,
          link: `/ato-mygovid-gdpr-compliant-agent-nomination/`,
        },
        documentManagement: {
          slug: `compliance-ready-document-management`,
          link: `/compliance-ready-document-management/`,
        },
        clientVerification: {
          slug: `ato-mygovid-compliant-agent-verification`,
          link: `/ato-mygovid-compliant-agent-verification/`,
        },
        fileManager: {
          slug: `file-manager`,
          link: `/file-manager/`,
        },
      },
    },
    individualsTab: {
      featurePages: {
        outlookAddin: {
          slug: `outlook-addin`,
          link: `/outlook-addin/`,
        },
        onlineSignature: {
          slug: `online-signature`,
          link: `/online-signature/`,
        },
        // expenseAndIncomeManagement: {
        //     slug: `expense-and-income-management`,
        //     link: `/expense-and-income-management/`
        // },
        claimDeductions: {
          slug: `claim-deductions`,
          link: `/claim-deductions/`,
        },
        clientOnboarding: {
          slug: `client-onboarding`,
          link: `/client-onboarding/`,
        },
        taskManagementAndReporting: {
          slug: `task-management-and-reporting`,
          link: `/task-management-and-reporting/`,
        },
        teamManagement: {
          slug: `team-management`,
          link: `/team-management/`,
        },
        connectToXero: {
          slug: `connect-to-xero`,
          link: `/connect-to-xero/`,
        },
        documentHub: {
          slug: `document-hub`,
          link: `/document-hub/`,
        },
        clientManagement: {
          slug: `client-management`,
          link: `/client-management/`,
        },
        synkliCapture: {
          slug: `synkli-capture`,
          link: `/synkli-capture/`,
        },
        jobManager: {
          slug: `job-manager`,
          link: `/job-manager/`,
        },
        emailManager: {
          slug: `email-manager`,
          link: `/email-manager/`,
        },
        collateDocuments: {
          slug: `collate-documents`,
          link: `/collate-documents/`,
        },
        deedBuilder: {
          slug: `deed-builder`,
          link: `/deed-builder/`,
        },
        thirdPartyAppsIntegrations: {
          slug: `third-party-apps-integrations`,
          link: `/third-party-apps-integrations/`,
        },
        efficientProfilesDataBuilding: {
          slug: `efficient-profiles-data-building`,
          link: `/efficient-profiles-data-building/`,
        },
        multipleProfilesManagement: {
          slug: `multiple-profiles-management`,
          link: `/multiple-profiles-management/`,
        },
        businessProfileManagement: {
          slug: `business-profile-management`,
          link: `/business-profile-management/`,
        },
        atoCompliantEthicalClearance: {
          slug: `ato-tpb-compliant-ethical-clearance`,
          link: `/ato-tpb-compliant-ethical-clearance/`,
        },
        agentNominationWizard: {
          slug: `ato-mygovid-gdpr-compliant-agent-nomination`,
          link: `/ato-mygovid-gdpr-compliant-agent-nomination/`,
        },
        documentManagement: {
          slug: `compliance-ready-document-management`,
          link: `/compliance-ready-document-management/`,
        },
        clientVerification: {
          slug: `ato-mygovid-compliant-agent-verification`,
          link: `/ato-mygovid-compliant-agent-verification/`,
        },
      },
    },
  },
  socialMediaLinks: [
    {
      socialPlatform: `facebook`,
      link: `https://www.facebook.com/Synkli.Official/`,
      icon: `facebook-icon`,
      alt: `Facebook`,
    },
    {
      socialPlatform: `instagram`,
      link: `https://www.instagram.com/synkli.official/`,
      icon: `instagram-icon`,
      alt: `Instagram`,
    },
    {
      socialPlatform: `pinterest`,
      link: `https://www.pinterest.com/synkli/`,
      icon: `pinterest-icon`,
      alt: `Pinterest`,
    },
    {
      socialPlatform: `Twitter`,
      link: `https://x.com/Synkli157373`,
      icon: `twitter-icon`,
      alt: `Twitter`,
    },
    {
      socialPlatform: `linkedin`,
      link: `https://www.linkedin.com/company/synkli/`,
      icon: `linkedin-icon`,
      alt: `LinkedIn`,
    },
    {
      socialPlatform: `youtube`,
      link: `https://www.youtube.com/@Synkli.Official`,
      icon: `youtube-icon`,
      alt: `YouTube`,
    },
    {
      socialPlatform: `tiktok`,
      link: `https://www.tiktok.com/@synkli.official`,
      icon: `tiktok-icon`,
      alt: `TikTok`,
    },
  ],
}

const bgColors = [
  "!bg-[#D6FAF3]",
  "!bg-[#FDF4E9]",
  "!bg-[#E0DFF9]",
  "!bg-[#DFEFFF]",
  "!bg-[#FFFBD0]",
  "!bg-[#F3D9B7]",
  "!bg-[#DEFFD7]",
  "!bg-[#C5FDF2]",
  "!bg-[#D9D3FF]",
]

const featuresPageLinkAccountant =
  "/" +
  siteDetails.pageMenuLinks.accountantPage.slug +
  siteDetails.postTypes.features.link
const featuresPageLinkBusinesses =
  "/" +
  siteDetails.pageMenuLinks.businessesPage.slug +
  siteDetails.postTypes.features.link
const featuresPageLinkSoletraders =
  "/" +
  siteDetails.pageMenuLinks.soleTradersPage.slug +
  siteDetails.postTypes.features.link
const featuresPageLinkIndividuals =
  "/" +
  siteDetails.pageMenuLinks.individualsPage.slug +
  siteDetails.postTypes.features.link

const caseStudyPageLinkAccountant =
  "/" +
  siteDetails.pageMenuLinks.accountantPage.slug +
  siteDetails.postTypes.caseStudies.link
const caseStudyPageLinkBusinesses =
  "/" +
  siteDetails.pageMenuLinks.businessesPage.slug +
  siteDetails.postTypes.caseStudies.link
const caseStudyPageLinkSoletraders =
  "/" +
  siteDetails.pageMenuLinks.soleTradersPage.slug +
  siteDetails.postTypes.caseStudies.link
const caseStudyPageLinkIndividuals =
  "/" +
  siteDetails.pageMenuLinks.individualsPage.slug +
  siteDetails.postTypes.caseStudies.link

const PROFILE_STORAGE_KEY = "synkli_profile_data"

const remoteAccessStaticData = {
  pending: {
    title: "Synkli Support Access",
    description:
      "Synkli Support is requesting permission to access your system for assistance.",
  },
  approved: {
    title: "Support Access Allowed",
    description:
      "You will be assigned a Support Member to help you with your system modifications shortly  ",
  },
  rejected: {
    title: "Support Access Denied",
    description:
      "You have denied Synkli Support access to your system. Assistance will not be provided until access is granted.",
  },
  cancelled: {
    title: "Support Access Removed",
    description:
      "Support Access has been removed. Assistance will not be provided until access is granted.",
  },
  used: {
    title: "Support Access Granted",
    description:
      "Support Access is active. The support team is securely connected to your account and providing assistance.",
  },
  closed: {
    title: "Support Access Closed",
    description:
      "Support Access has been closed. The support team is no longer connected to your account.",
  },
}

module.exports = {
  siteDetails,
  bgColors,
  featuresPageLinkAccountant,
  featuresPageLinkBusinesses,
  featuresPageLinkSoletraders,
  featuresPageLinkIndividuals,
  caseStudyPageLinkAccountant,
  caseStudyPageLinkBusinesses,
  caseStudyPageLinkSoletraders,
  caseStudyPageLinkIndividuals,
  PROFILE_STORAGE_KEY,
  remoteAccessStaticData,
}
